export default function PHP_getTrace() {
  return (
    <div>
      <h1>PHP_getTrace</h1>
    </div>
  );
}
